import { Box, Checkbox, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import ConfirmComp from "src/components/shared/ConfirmComp";
import CopyToClipboard from "src/components/shared/CopyToClipboard";
import {
  ORDER_SOUCE_TYPE,
  ORDER_SOURCE_TYPE,
  ORDER_SOURCE_TYPE_TRANSLATE,
  ORDER_STATUS_TRANSLATE,
  ORDER_STATUS_TYPE,
  orderStatusFormatted,
  RETURN_REFUND_OPTIONS_TRANSLATE,
} from "src/constant";
import useAppGlobal from "src/context/useAppGlobal";
import useOrderByCodeLookup from "src/hooks/orders/useOrderByCodeLookup";
import useOrderList from "src/hooks/orders/useOrderList";
import useQueryParams from "src/hooks/useQueryParams";
import { v4 as uuid } from "uuid";
import PrintView from "src/components/shared/PrintView";
import OrderDetailDialog from "../all-order/OrderDetailDialog";
import UpdateBtn from "src/components/shared/UpdateBtn";
import OrderCreateDialog from "../all-order/OrderCreateDialog";
import DeleteBtn from "src/components/shared/DeleteBtn";
import useOrderRemove from "src/hooks/orders/useOrderRemove";
import useAuthGlobal from "src/context/useAuthGlobal";
import OrderActionGroup from "../all-order/OrderActionGroup";
import { solveOrderType } from "src/helper/orderType";
import ViewBtn from "src/components/shared/ViewBtn";
import ProcessingBadge from "src/components/shared/ProcessingBagde";
import useRedirect from "src/helper/direct";
import usePreviewPdf from "../../debt/hooks/usePreviewPdf";
import { EXPORT_TYPE } from "src/constant";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";

export default function useOrderBody({ warehouseId, setOrderIds, orderIds, paramsQuery, keyWord, searchBy, topbarSearchList, mutate }) {
  const permissionCheck = useRoleCheck();
  const [option] = useQueryParams();
  const { closeDialog, handleOpenDialog } = useAppGlobal();
  const { userMe } = useAuthGlobal();
  const redirect = useRedirect();

  const [orderId, setOrderId] = useState();
  const [pagi, setPagi] = useState({
    limit: 50,
    skip: 0,
  });

  const selectedSearch = topbarSearchList.find((item) => item.id === searchBy) ?? topbarSearchList[0];
  const selectedSearchValue = selectedSearch?.value;
  const isShippingCodeSearch = selectedSearchValue === "shippingCode";
  const isOtherSearchValue = ["customer", "sales", "itemCode"].includes(selectedSearchValue);
  const { onPrintOrder } = usePreviewPdf();

  const { data: orderByCodeRes } = useOrderByCodeLookup(isShippingCodeSearch && keyWord ? keyWord : null, warehouseId);

  const { data: ordersList } = useOrderList(
    warehouseId && !(isShippingCodeSearch && keyWord)
      ? {
          ...pagi,
          ...paramsQuery,
          warehouse: warehouseId,
          searchField: keyWord && !isOtherSearchValue && !isShippingCodeSearch ? selectedSearchValue : undefined,
          searchValue: keyWord && !isOtherSearchValue && !isShippingCodeSearch ? keyWord : undefined,
          status: [orderStatusFormatted.Manual, orderStatusFormatted.ReturnRefund, orderStatusFormatted.Exchange]?.includes(option?.tab)
            ? undefined
            : !!ORDER_STATUS_TYPE[option?.tab]
              ? ORDER_STATUS_TYPE[option?.tab]
              : option?.tab === orderStatusFormatted.all
                ? undefined
                : option?.tab,
          type: solveOrderType(option?.tab),
          source: !!paramsQuery?.source ? (paramsQuery?.source === ORDER_SOURCE_TYPE.All ? undefined : paramsQuery?.source) : ORDER_SOUCE_TYPE[option?.tab],
          trackingStatus: [orderStatusFormatted.Manual, orderStatusFormatted.ReturnRefund, orderStatusFormatted.DeliveredFailed, orderStatusFormatted.Exchange]?.includes(
            option?.tab,
          )
            ? option?.childTab === orderStatusFormatted.all
              ? undefined
              : option?.childTab
            : undefined,
          ...(isOtherSearchValue && { [selectedSearchValue]: keyWord ? keyWord : undefined }),
        }
      : null,
  );

  const orders =
    isShippingCodeSearch && keyWord
      ? orderByCodeRes?.success && orderByCodeRes?.data
        ? { ...orderByCodeRes, data: [orderByCodeRes.data], count: 1 }
        : { data: [], count: 0 }
      : ordersList;

  const { trigger: remove } = useOrderRemove(orderId);

  const handleSendAll = (id) => {
    if (!id) {
      if (orders?.data?.length === orderIds?.length) {
        setOrderIds([]);
      } else {
        setOrderIds(orders?.data?.map((v) => v?._id));
      }
    } else {
      const item = orderIds?.includes(id);
      if (!!item) {
        setOrderIds(orderIds?.filter((v) => v !== id));
      } else {
        setOrderIds((prev) => [...prev, id]);
      }
    }
  };

  const header = [
    {
      id: uuid(),
      title: "Đơn hàng",
      align: "center",
      comp: (
        <Checkbox
          checked={orderIds?.length === orders?.data?.length}
          onClick={() => handleSendAll(undefined)}
        />
      ),
      display: [orderStatusFormatted.ReadyToPick, orderStatusFormatted.Delivering]?.includes(option.tab),
    },
    {
      id: uuid(),
      title: "STT",
      align: "center",
    },
    {
      id: uuid(),
      title: "Mã phiếu xuất",
      align: "center",
      display: ![orderStatusFormatted.Pending, orderStatusFormatted.WaitToProcess, orderStatusFormatted.WaitToExport]?.includes(option?.tab),
    },
    {
      id: uuid(),
      title: "Đơn hàng",
      align: "center",
    },
    {
      id: uuid(),
      title: "Trạng thái",
      align: "center",
    },
    {
      id: uuid(),
      title: "Nguồn",
      align: "center",
    },
    {
      id: uuid(),
      title: "ĐVVC",
      align: "center",
    },
    {
      id: uuid(),
      title: "Xác nhận ĐH",
      align: "center",
    },
    {
      id: uuid(),
      title: "Thao tác",
      align: "center",
    },
  ];

  const handleViewPrint = (item) => {
    handleOpenDialog({
      title: "In đơn hàng",
      content: (
        <OrderDetailDialog
          id={item?._id}
          whouseId={item?.warehouse}
        />
      ),
      size: "xl",
    });
  };

  const handleUpdate = (item) => {
    // redirect(`/order/create?id=${item?._id}`);
    handleOpenDialog({
      title: "Cập nhật đơn hàng",
      content: (
        <OrderCreateDialog
          item={item}
          whouseId={item?.warehouse}
          isUpdate
        />
      ),
      size: "xl",
    });
  };

  const handleDeleteConfirm = (item) => {
    handleOpenDialog({
      content: (
        <ConfirmComp
          name={item?.code}
          onConfirm={() => handleRemove(item?._id)}
        />
      ),
      size: "md",
    });
  };

  const handleRemove = async () => {
    const res = await remove({
      body: {
        warehouse: warehouseId ?? userMe?.currentWarehouse?._id,
      },
    });
    if (res?.success) {
      closeDialog();
      return enqueueSnackbar("Thành công", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message ?? "Có lỗi xảy ra", { variant: "error" });
    }
  };

  useEffect(() => {
    setOrderId([]);
  }, [option?.tab]);

  const handleView = (value) => {
    return redirect(`/orders/${value?._id}?warehouseId=${value?.warehouse}`);
  };

  const bodyList = Array.isArray(orders?.data)
    ? orders?.data?.map((v, index) => ({
        ...v,
        ...([orderStatusFormatted.ReadyToPick, orderStatusFormatted.Delivering]?.includes(option.tab)
          ? {
              checkbox: (
                <Checkbox
                  onClick={() => handleSendAll(v?._id)}
                  checked={orderIds?.includes(v?._id)}
                />
              ),
            }
          : ""),
        no: <Typography align="center">{index + 1}</Typography>,
        exportedCode: v?.innNoteCode ? <CopyToClipboard value={v?.innNoteCode} /> : "-",
        status: (
          <Box textAlign="center">
            <ProcessingBadge
              value={ORDER_STATUS_TRANSLATE[v?.trackingStatus]}
              asset={{ color: v?.trackingStatus, text: v?.trackingStatus }}
            />
            {!!v?.currentSubOrder && (
              <Typography
                sx={{
                  fontSize: "10px",
                  textAlign: "center",
                  mt: "4px",
                  fontWeight: "bold",
                  color: "var(--error)",
                }}
              >
                {RETURN_REFUND_OPTIONS_TRANSLATE[v?.currentSubOrder?.type]}
              </Typography>
            )}
            {[orderStatusFormatted.Returned, orderStatusFormatted.ReturnFailed]?.includes(v.status) && (
              <Typography
                fontSize="10px"
                color="var(--error)"
                textAlign="center"
                mt="4px"
                fontWeight="bold"
                sx={{ cursor: "pointer" }}
                onClick={() => onPrintOrder(v, EXPORT_TYPE.PickingList)}
              >
                {v?.code}
              </Typography>
            )}
          </Box>
        ),
        orderCode: (
          <Box
            display="flex"
            justifyContent="center"
            flexDirection="column"
          >
            {v?.rootOrder?.code ? (
              <>
                <CopyToClipboard value={v?.rootOrder?.code} />
                <Typography
                  color="error"
                  fontWeight="bold"
                  fontSize="10px"
                >
                  ({v?.type === orderStatusFormatted.ReturnRefund ? "Mã ĐH trả: " : "Mã ĐH đổi: "}
                  {v?.code})
                </Typography>
              </>
            ) : (
              <>
                <CopyToClipboard value={v?.code} />
                {/* <Typography
                  variant="caption"
                  color="error"
                  fontWeight="bold"
                >
                  ({v?.code})
                </Typography> */}
              </>
            )}
          </Box>
        ),
        TP: (
          <Box textAlign="center">
            <Typography
              variant="body2"
              sx={{ whiteSpace: "nowrap" }}
            >
              Mã ĐVVC đang phát triển...
            </Typography>
            <Typography fontWeight="bold">({v?.shippingProvider?.name ?? "-"})</Typography>
          </Box>
        ),
        sourceConvert: <Typography align="center">{ORDER_SOURCE_TYPE_TRANSLATE[v?.source]}</Typography>,
        require: v?.trackingStatus !== orderStatusFormatted.Pending ? "deny" : "default",
        approve: (
          <OrderActionGroup
            item={v}
            mutate={mutate}
          />
        ),
        action: (
          <Box
            display="flex"
            gap="6px"
            justifyContent="center"
          >
            {v?.trackingStatus === orderStatusFormatted.WaitToExport && <UpdateBtn handleUpdate={() => handleUpdate(v)} />}
            <ViewBtn
              disabled={!permissionCheck([PERMISSIONS.VIEW_ORDER_ALL, PERMISSIONS.VIEW_ORDER_OWN])}
              handleView={() => handleView(v)}
            />
            <PrintView
              disabled={!permissionCheck([PERMISSIONS.VIEW_ORDER_ALL, PERMISSIONS.VIEW_ORDER_OWN])}
              handleView={() => handleViewPrint(v)}
            />
            {v?.trackingStatus === orderStatusFormatted.WaitToExport && (
              <DeleteBtn
                disabled={!permissionCheck([PERMISSIONS.DELETE_ORDER_ALL, PERMISSIONS.DELETE_ORDER_OWN])}
                handleDelete={() => {
                  setOrderId(v?._id);
                  handleDeleteConfirm(v);
                }}
              />
            )}
          </Box>
        ),
        ...([
          orderStatusFormatted.ReadyToPick,
          orderStatusFormatted.DeliveredFailed,
          orderStatusFormatted.Exchange,
          orderStatusFormatted.Manual,
          orderStatusFormatted.Delivered,
        ]?.includes(option.tab) && {
          exportdCode: !!v?.rootOrder?.innNoteCode || v?.innNoteCode ? <CopyToClipboard value={v?.rootOrder?.innNoteCode ?? v?.innNoteCode} /> : "-",
        }),
      }))
    : [];

  const sortData = ["checkbox", "no", "exportedCode", "orderCode", "status", "sourceConvert", "TP", "approve", "action"];
  return { header, sortData, bodyList, setPagi, pagi, total: orders?.count ?? 0 };
}
